import {
  ImageResource,
  LocalImage,
  ManagedImage,
  RemoteImage,
  SparkelloImage,
} from 'sparkello-core';
import { WebManagedImageUtil } from '@/web/image/WebManagedImageUtil';
// import {ImageRequireSource, ImageSourcePropType, ImageURISource} from "react-native";
// import ImageResizer from 'react-native-image-resizer';
// import storage, {FirebaseStorageTypes} from '@react-native-firebase/storage';
// import auth from '@react-native-firebase/auth';
// import 'react-native-get-random-values';
// import {v4 as uuidv4} from 'uuid';
// import {ManagedImageUtil} from "@src/sparkello-react-native/image/ManagedImageUtil";

export const defaultDreamImage = 'http://localhost:8080/assets/img/background/background06@2x.jpg';

export class SparkelloImageUtil {

  private static inst: SparkelloImageUtil;
  // private managedImageUtil: WebManagedImageUtil = new WebManagedImageUtil();
  // private managedImageUtil: ManagedImageUtil = new ManagedImageUtil();

  public static get instance(): SparkelloImageUtil {
    if (!SparkelloImageUtil.inst) {
      SparkelloImageUtil.inst = new SparkelloImageUtil();
    }
    return this.inst;
  }

  public async getRegularImageSource(image?: SparkelloImage, defaultImage?: string): Promise<string> {

    if (!image || !image.isValid()) {
      console.info('Data incomplete - no images to display');
      return defaultDreamImage;
    }

    const imgResource = image.regularImage ? image.regularImage : (image.largeImage ? image.largeImage : image.thumbImage);
    return this.getImageSource(imgResource, defaultImage);
  }

  public async getLargeImageSource(image?: SparkelloImage, defaultImage?: string): Promise<string> {

    if (!image || !image.isValid()) {
      console.info('Data incomplete - no images to display');
      return defaultDreamImage;
    }

    const imgResource = image.largeImage ? image.largeImage : (image.regularImage ? image.regularImage : image.thumbImage);
    return this.getImageSource(imgResource, defaultImage);
  }

  public async getThumbImageSource(image?: SparkelloImage, defaultImage?: string): Promise<string> {

    if (!image || !image.isValid()) {
      console.info('Data incomplete - no images to display');
      return defaultDreamImage;
    }

    const imgResource = image.thumbImage ? image.thumbImage : (image.regularImage ? image.regularImage : image.largeImage);
    return this.getImageSource(imgResource, defaultImage);
  }

  private static resolveManagedImage(image?: ImageResource,
                                     defaultImage?: string): string {
    if (image?.uri) {
      return image.uri
    }
    return defaultImage || defaultDreamImage;
  }

  /**'
   *
   */
  public async getImageSource(image?: ImageResource,
                        defaultImage?: string,
                        managedImageSize: 'lg' | 'md' | 'sm' = 'md'): Promise<string> {

    if (!image) {
      return defaultImage || defaultDreamImage;
    }
    switch (image.type) {
      case 'REMOTE_IMAGE': {
        const img = image as RemoteImage;
        console.log('Remote Image');
        return img.uri;
      }
      case 'MANAGED_IMAGE': {
        const img = image as ManagedImage;
        console.log('Managed Image', img);
        if (img?.uri) {
          return img.uri;
        }
        const bgImage = await WebManagedImageUtil.instance.getManagedImage(img.id);
        console.log('Background Image', bgImage);
        switch (managedImageSize) {
          case 'lg':
            const lgUri = SparkelloImageUtil.resolveManagedImage(bgImage?.largeImage);
            img.uri = lgUri;
            return lgUri;
          case 'md':
            const mdUri =  SparkelloImageUtil.resolveManagedImage(bgImage?.regularImage);
            img.uri = mdUri;
            return mdUri;
          case 'sm':
            const smUri =  SparkelloImageUtil.resolveManagedImage(bgImage?.thumbImage);
            img.uri = smUri;
            return smUri;
          default:
            return defaultImage || defaultDreamImage;
        }
      }
      case 'LOCAL_IMAGE': {
        const img = image as LocalImage;
        console.log('Local Image');
        return img.uri;
      }
      default:
        console.error('Un-supported Image Resource type');
        return defaultDreamImage;
    }
  }



  // /**
  //  * For the given SparkelloImage definition, compresses and resizes images, and uploads them to cloud storage
  //  * @param image
  //  * @param storeWithUserData
  //  */
  // public async prepareAndUploadLocalImage(image: SparkelloImage, storeWithUserData: boolean = true): Promise<SparkelloImage> {
  //     console.log('SparkelloImageUtil.prepareAndUploadLocalImage:', image)
  //
  //
  //     if (image?.largeImage?.type == 'LOCAL_IMAGE') {
  //         console.log('Resize Regular Image')
  //         const uncompressedImage = image.largeImage as LocalImage;
  //         image.largeImage = await this.resizeImage(uncompressedImage, maxDimensions.large.width, maxDimensions.large.height, maxDimensions.large.quality)
  //         image.thumbImage = await this.resizeImage(uncompressedImage, maxDimensions.thumb.width, maxDimensions.thumb.height, maxDimensions.large.quality)
  //         image.regularImage = await this.resizeImage(uncompressedImage, maxDimensions.regular.width, maxDimensions.regular.height, maxDimensions.large.quality)
  //
  //         image = await this.uploadImages(image);
  //     }
  //
  //     return image;
  // }
  //
  // public async resizeImage(localImage: LocalImage | undefined, maxWidth: number, maxHeight: number, quality: number): Promise<ImageResource | undefined> {
  //
  //     if (!localImage || localImage.type != 'LOCAL_IMAGE') {
  //         return localImage;
  //     }
  //
  //     console.log('SparkelloImageUtil.resizeImage - Data:', localImage)
  //
  //     let image = localImage;
  //
  //     await ImageResizer.createResizedImage(localImage.uri, maxWidth, maxHeight,
  //         'JPEG', quality, 0, undefined, false,
  //         {
  //             mode: 'contain',
  //             onlyScaleDown: true
  //         })
  //         .then(response => {
  //             console.log('SparkelloImageUtil.resizeImage:', response)
  //             image = new LocalImage({
  //                 uri: response.uri,
  //                 height: response.height,
  //                 width: response.width,
  //             })
  //         })
  //         .catch(err => {
  //             console.error('SparkelloImageUtil.resizeImage:', err)
  //             throw new Error('SparkelloImageUtil.resizeImage: ' + err)
  //         });
  //
  //     return image
  // }
  //
  // async uploadImages(image: SparkelloImage): Promise<SparkelloImage> {
  //     console.log('SparkelloImageUtil.uploadImages', image);
  //
  //     if (!auth().currentUser?.uid) {
  //         console.error('User is not logged in. Can\'t store image.');
  //         throw new Error('User is not logged in. Can\'t store image.');
  //     }
  //
  //     const uniqueId = uuidv4();
  //     console.log('Unique ID', uniqueId)
  //
  //
  //     const destLg = storage().ref('dreams/images').child(auth().currentUser?.uid as string).child(uniqueId + '-lg.jpg');
  //     const destMd = storage().ref('dreams/images').child(auth().currentUser?.uid as string).child(uniqueId + '-md.jpg');
  //     const destSm = storage().ref('dreams/images').child(auth().currentUser?.uid as string).child(uniqueId + '-sm.jpg');
  //
  //     await Promise.all(
  //         [
  //             this.uploadSingleImage(image.largeImage as LocalImage, destLg),
  //             this.uploadSingleImage(image.regularImage as LocalImage, destMd),
  //             this.uploadSingleImage(image.thumbImage as LocalImage, destSm)
  //         ])
  //         .then((values) => {
  //             console.log(values);
  //             image.largeImage = values[0];
  //             image.regularImage = values[1];
  //             image.thumbImage = values[2];
  //         });
  //
  //     return image;
  // }
  //
  // async uploadSingleImage(imageResource: LocalImage, dest: FirebaseStorageTypes.Reference): Promise<RemoteImage> {
  //
  //     let remoteImg: RemoteImage;
  //
  //     //Set cache age to 1 month
  //     const metadata = {
  //         cacheControl: 'public, max-age=2592000'
  //     };
  //
  //     const task = dest.putFile(imageResource.uri as string, metadata)
  //
  //     await task.on('state_changed', taskSnapshot => {
  //         console.log(`${taskSnapshot.bytesTransferred} transferred out of ${taskSnapshot.totalBytes}`);
  //     });
  //
  //     await task.then((snapshot) => {
  //         console.log('Saved image', snapshot);
  //     }).catch((e) => {
  //         console.error('Well that didn\'t work',e);
  //     });
  //
  //     const url = await dest.getDownloadURL();
  //
  //     console.log(url, imageResource);
  //     remoteImg = new RemoteImage({
  //         uri: url,
  //         height: imageResource?.height,
  //         width: imageResource?.width,
  //         aspectRatio: imageResource?.aspectRatio
  //     });
  //
  //
  //     console.log('New Image Resource', remoteImg);
  //
  //     return remoteImg;
  // }

}

//
// const maxDimensions = {
//     large: {width: 800, height: 2000, quality: 80},
//     regular: {width: 400, height: 1200, quality: 80},
//     thumb: {width: 200, height: 400, quality: 80},
// }


